import React from 'react';
import { useDispatch } from 'react-redux';

import GetImmigrationStatus from '@src/api/GetImmigrationStatus';
import { generateImmigrationStatus } from '@src/factories';
import useAxiosErrorHandler from '@src/hooks/useAxiosErrorHandler';
import useAxiosRequestConfig from '@src/hooks/useAxiosRequestConfig';
import { setImmigrationStatus as setImmigrationStatusAction } from '@src/store/authentication/actions';

import useAuthenticationTokens from './useAuthenticationTokens';

const useRefreshProfile = (manual?: boolean) => {
  const {
    tokens: { userID, accessToken },
  } = useAuthenticationTokens();
  const dispatcher = useDispatch();
  const axiosRequestConfig = useAxiosRequestConfig();
  const axiosErrorHandler = useAxiosErrorHandler();

  const makeRequest = React.useCallback(async () => {
    if (!userID || !accessToken) {
      return;
    }
    try {
      const response = await GetImmigrationStatus(axiosRequestConfig);
      dispatcher(
        setImmigrationStatusAction(
          generateImmigrationStatus(
            response.data.content.filter((e) => e.planType === 'PRIME_PLUS')[0]
          )
        )
      );
    } catch (e) {
      const result = axiosErrorHandler(e);
      if (result.status === 403) {
        dispatcher(
          setImmigrationStatusAction({
            planType: 'PRIME_PLUS',
            hasAccess: undefined,
            daysRemaining: undefined,
            totalDays: undefined,
            beginDate: undefined,
            expirationDate: undefined,
          })
        );
      }
    }
  }, [accessToken, axiosErrorHandler, axiosRequestConfig, dispatcher, userID]);

  React.useEffect(() => {
    if (!manual) {
      makeRequest().catch(console.log);
    }
  }, [makeRequest, manual]);

  return makeRequest;
};

export default useRefreshProfile;
